import React, { useState } from 'react';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Menu, MenuItem } from '@material-ui/core';
import { UserDtoType } from '../../../types/dto/UserDtoType';
import { getEllapsedTime } from '../../../helpers/getEllapsedTime';
import { ASSETS_BASE_URL } from '../../../lib/constants';
import { TopRightToast } from '../../../helpers/toastMsg';

type UserContentContainerHeaderProps = {
  className?: string;
  author: UserDtoType;
  createdAt?: string;
  deleteText?: string;
  isPoll?: boolean;
  isVoted?: boolean;
  isAuth?: boolean;
  selfContent?: boolean;
  onDelete?: () => any;
  onClear?: () => any;
  pollEnded?: boolean;
  postId?: number;
};

export function UserContentContainerHeader({
  className,
  author,
  createdAt,
  deleteText,
  isPoll,
  isVoted,
  isAuth,
  selfContent,
  onDelete,
  onClear,
  pollEnded,
  postId
}: UserContentContainerHeaderProps) {
  const [menuAnchor, setMenuAnchor] = useState(null);

  const handleMenuClick = event => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const deleteHandler = () => {
    handleMenuClose();
    onDelete();
  };

  const clearHandler = () => {
    handleMenuClose();
    onClear();
  };

  const handleShareClick = async () => {
    const baseUrl = window.location.origin + window.location.pathname;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(isPoll ? `${baseUrl}?poll_id=${postId}` : `${baseUrl}?post_id=${postId}`);
      TopRightToast("Link has been copied to the clipboard!");
    } else {
      // Fallback for older browsers: copy text to a temporary element
      const textArea = document.createElement("textarea");
      textArea.value = baseUrl + (isPoll ? `?poll_id=${postId}` : `?post_id=${postId}`);
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      textArea.remove();
      TopRightToast("Link has been copied to the clipboard!");
    }
    setMenuAnchor(null);
  };

  const isMenuOpen = !!menuAnchor;

  return (
    <div className={`flex justify-between ${className || ''}`}>
      <div className="font-bold text-base author-hot-comment">{author.username}</div>
      <div className="flex items-center">
        {createdAt ? (
          <div className="text-purple-light capitalize mr-2">
            {getEllapsedTime(createdAt)}
          </div>
        ) : null}
        <button
          className="cursor-pointer rounded-full px-2 focus:outline-none"
          onClick={handleMenuClick}
          disabled={false}
        >
          <FontAwesomeIcon icon={faEllipsisV} />
        </button>
      </div>

      <Menu
        anchorEl={menuAnchor}
        open={isMenuOpen}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => {}} disabled={true}>
          <img className="h-4" src={`${ASSETS_BASE_URL}system/cw-assets/report.svg`} alt="Report icon" />
          <div className="ml-2 text-sm">Report</div>
        </MenuItem>
        {postId ? <MenuItem onClick={handleShareClick} disabled={false}>
          <div className="ml-2 text-sm">{`Share`}</div>
        </MenuItem> : null}
        {selfContent && (
          <MenuItem onClick={deleteHandler} disabled={!selfContent}>
            <img className="h-4" src={`${ASSETS_BASE_URL}system/cw-assets/trash.svg`} alt="Trash icon" />
            <div className="ml-2 text-sm">{deleteText}</div>
          </MenuItem>
        )}
        {isPoll && (
          <MenuItem onClick={clearHandler} disabled={!isVoted || pollEnded}>
            <div className="text-sm">Clear my vote</div>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}
